import React, { useState, useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom';
import { BreadCrumb } from '../../common/breadcrumb';
import api from '../../../services/axios';
import Swal from "sweetalert2";
import { useJWTAuth } from '../../../services/JWTAuthProvider';
import { userRole } from '../../../constants/appConst';

export const EditUser = (props) => {
    const { user } = useJWTAuth();
    const userInfo = user;
    const navigate = useNavigate();
    const [selectedDropdownItem, setSelectedDropdownItem] = useState('');
    const location = useLocation();
    const { email: emailFromState, name: nameFromState, role: roleFromState, userIdentifier: identifierfromState, isssologin: ssoFromState } = location.state || { email: '', name: '', role: '', userIdentifier: '', isssologin: '' };
    const [email] = useState(emailFromState);
    const [name, setName] = useState(nameFromState);
    const [role, setRole] = useState(roleFromState);
    const [userIdentifier] = useState(identifierfromState);
    const [subBtnDisabled, setSubBtnDisabled] = useState(false);
    const [formValues, setFormValues] = useState({
        name: '',
        id: '',
        password: '',
        confirm: '',
    });
    const [formErrors, setFormErrors] = useState({
        name: '',
        id: '',
        password: '',
        confirm: '',
        folders: ''
    });
    const [isFormSubmitted, setIsFormSubmitted] = useState(false);
    const [passwordMatchError, setPasswordMatchError] = useState(false);
    const [nameRegexError, setNameRegexError] = useState(false);
    const [nameRequiredError, setnameRequiredError] = useState(false);
    const [roleSelection, setRoleSelection] = useState('');
    const [selectedFolders, setSelectedFolders] = useState([]);
    const [selectFolderError, setFolderError] = useState(false);

    const roleMapping = {
        1: "Global Admin",
        2: "Business Unit Admin",
        3: "Business Unit User"
    };

    const handleDropdownItemClick = (number) => {
        setSelectedDropdownItem(roleMapping[number]);
        if (number === 1) {
            setFolderError(false);
            setSubBtnDisabled(false)
        }
        setRoleSelection(number);
    };


    const handleclose = () => {
        navigate('/UserManagement');
    }


    const [folderList, setFolderList] = React.useState([]);
    React.useEffect(() => {
        const getData = async () => {
            try {
                const { data } = await api.get("/Folders/getrootfolders?Id=" + userInfo.id);
                setFolderList(data.result.folders);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        }
        const getAccessData = async () => {
            try {
                const { data } = await api.get("Folders?userId=" + userIdentifier);
                setSelectedFolders(data.result.folderLists.map(e => e.folderIdentifier));
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        }
        getData();
        getAccessData();
    }, []);

    const breadcrumbItems = [
        { label: 'Home Page', url: '/' },
        { label: 'User Management', url: '/UserManagement' },
        { label: 'Edit User', url: '' },
    ];

    const handleNameChange = (event) => {
        setName(event.target.value);
        setnameRequiredError(false);
        setNameRegexError(false);
        setSubBtnDisabled(false);
    };

    const handleInputChange = (fieldName, value) => {
        setFormErrors({ ...formErrors, [fieldName]: '' });

        if (fieldName === 'confirm') {
            setPasswordMatchError(false);
        }

        setFormValues({ ...formValues, [fieldName]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsFormSubmitted(true);
        setSubBtnDisabled(true)
        // Fetch form values
        const updatedName = name;
        const identifier = userIdentifier;

        if (name === '') {
            setnameRequiredError(true);
            setSubBtnDisabled(false);
            return;
        }

        if (name) {
            const regex = /^[a-zA-Z0-9' ]+$/;

            // Check if the entered username matches the pattern
            const isValid = regex.test(name);
            if (!isValid) {
                setNameRegexError(true);
                setSubBtnDisabled(false);
                return;
            }
        }
        if (roleSelection !== userRole.GlobalAdmin && selectedFolders.length === 0) {
            setFolderError(true);
            setSubBtnDisabled(false);
            return;
        }
        try {
            const { data } = await api.put("/User/UpdateUserInfo", {
                name: updatedName,
                userid: identifier,
                role: roleSelection,
                folders: selectedFolders,
            });
            if (data.statusCode === 200) {
                Swal.fire({
                    position: "center",
                    icon: "success",
                    text: "User updated successfully",
                    confirmButtonText: "Ok",
                    timer: 3000,
                    timerProgressBar: true
                }).then(val => {
                    if (val) {
                        navigate('/UserManagement');
                    }
                });;
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        }
        setSubBtnDisabled(false)
    };

    const handleFolderSelection = (folder) => {
        setFolderError(false);
        // Add or remove the selected folder from the array
        setSelectedFolders((prevSelected) => {
            if (prevSelected.includes(folder)) {
                return prevSelected.filter((item) => item !== folder);
            } else {
                return [...prevSelected, folder];
            }
        });
    };

    const CheckAll = () => {
        if (selectedFolders.length === 0 && selectedFolders.length < folderList.length) {
            return true;
        }
        else if (selectedFolders.length < folderList.length) {
            return true;
        }
        else {
            return false;
        }
        setFolderError(false);
    }

    const handleSelectAllFolders = (e) => {
        setFolderError(false);
        if (e.target.checked) {
            // Select all folders
            setSelectedFolders(folderList.map(li => li.folderIdentifier));
        } else {
            // Deselect all folders
            setSelectedFolders([]);
        }
    };

    useEffect(() => {
        setSelectedDropdownItem(roleMapping[role]);
        setRoleSelection(role);
        setRole(role);
    }, [role]);
    return (
        <>
            <div className='right-content'>

                <BreadCrumb items={breadcrumbItems}></BreadCrumb>

                <div className='mid-box-wrap'>
                    <h4 className='sub-head'>Edit User</h4>
                    <form className='add-form' onSubmit={handleSubmit}>
                        <div className='row'>
                            <div className='col-md-6 add-user-label'>
                                <div class="mb-2">
                                    <label for="name" class="form-label">Name</label>
                                    <input
                                        type="text"
                                        className={`form-control ${formErrors.name && 'error'}`}
                                        id="name"
                                        placeholder="Enter name"
                                        value={name}
                                        maxLength="200"
                                        onChange={handleNameChange}

                                    />
                                    {isFormSubmitted && formErrors.name && (
                                        <p className="error-message">{formErrors.name}</p>
                                    )}
                                    {nameRegexError && (
                                        <p className="error-message">* Name should be in valid format</p>
                                    )}
                                    {nameRequiredError && (
                                        <p className="error-message">* Name is required</p>
                                    )}
                                </div>
                                <div class="mb-2">
                                    <label for="id" class="form-label">User ID</label>
                                    <input
                                        type="text"
                                        className={`form-control ${formErrors.id && 'error'}`}
                                        id="id"
                                        placeholder="Enter User ID"
                                        maxLength="100"
                                        value={email} disabled
                                        onChange={(e) => handleInputChange('id', e.target.value)}
                                    />
                                    {isFormSubmitted && formErrors.id && (
                                        <p className="error-message">{formErrors.id}</p>
                                    )}
                                </div>

                                <div class="mb-2">
                                    <label for="password" class="form-label">Password</label>
                                    <input
                                        type="password"
                                        className={`form-control ${formErrors.password && 'error'}`}
                                        id="password"
                                        placeholder="Enter Password" disabled
                                        value={formValues.password}
                                        onChange={(e) => handleInputChange('password', e.target.value)}
                                    />
                                    {isFormSubmitted && formErrors.password && (
                                        <p className="error-message">{formErrors.password}</p>
                                    )}
                                    {passwordMatchError && (
                                        <p className="error-message">* Confirm Password does not match the Password</p>
                                    )}
                                </div>
                                <div class="mb-2">
                                    <label for="confirm" class="form-label">Confirm Password</label>
                                    <input
                                        type="text"
                                        className={`form-control ${formErrors.confirm && 'error'}`} disabled
                                        id="confirm"
                                        placeholder="Enter Confirm Password"
                                        value={formValues.confirm}
                                        onChange={(e) => handleInputChange('confirm', e.target.value)}
                                    />
                                    {isFormSubmitted && formErrors.confirm && (
                                        <p className="error-message">{formErrors.confirm}</p>
                                    )}
                                </div>

                            </div>
                            <div className='col-md-6 add-user-label'>
                                <div class="mb-2">
                                    <label for="dropdownMenuButton1" class="form-label">Role</label>
                                    <div className="dropdown">
                                        <button className="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                                            {selectedDropdownItem}
                                        </button>
                                        <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                            {user.role === userRole.BusinessUnitAdmin ? null :
                                                <li onClick={() => handleDropdownItemClick(1)}><span className="dropdown-item">Global Admin</span></li>
                                            }                                            <li onClick={() => handleDropdownItemClick(2)}><span className="dropdown-item">Business Unit Admin</span></li>
                                            <li onClick={() => handleDropdownItemClick(3)}><span className="dropdown-item">Business Unit User</span></li>
                                        </ul>
                                    </div>
                                    {isFormSubmitted && (formErrors.role || roleSelection === 'Select Role') && roleSelection !== 'Select Role' && (
                                        <p className="error-message">{formErrors.role}</p>
                                    )}
                                </div>
                                <div className={`mb-2 ${roleSelection === 1 ? 'role-show' : ''}`}>
                                    <label class="form-label">Select Folder</label>
                                    <div className='select-folder'>
                                        <div className='folder-check-wrap'>
                                            <div className='all-check'>
                                                <input type="checkbox" id='all' onChange={handleSelectAllFolders} checked={CheckAll() ? false : true} disabled={roleSelection === 'Global Admin'} /> <label for="all">Select All Folders</label>
                                            </div>
                                            {folderList.map((folder) => (
                                                <div className='single-check'>
                                                    <input type="checkbox" id={folder.folderIdentifier} checked={selectedFolders.includes(folder.folderIdentifier)} onChange={() => handleFolderSelection(folder.folderIdentifier)} /> <label for={folder.name} ><img src="../Assets/folder-icon.svg" alt='User' /> {folder.name}</label>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                    {isFormSubmitted && formErrors.folders && roleSelection !== 'Global Admin' && selectedFolders.length === 0 && (
                                        <p className="error-message">* Please select at least one folder</p>
                                    )}
                                    {selectFolderError && (
                                        <p className="error-message">* Please select at least one folder</p>
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" onClick={handleclose}>
                                Cancel
                            </button>
                            <button className='btn btn-primary' disabled={subBtnDisabled} type='submit'>Submit</button>
                        </div>
                    </form>
                </div>
            </div>
        </>
    )
}
